import { render, staticRenderFns } from "./managerIndex.vue?vue&type=template&id=180faea2&scoped=true&"
import script from "./managerIndex.vue?vue&type=script&lang=js&"
export * from "./managerIndex.vue?vue&type=script&lang=js&"
import style0 from "./managerIndex.vue?vue&type=style&index=0&id=180faea2&scoped=true&lang=css&"
import style1 from "./managerIndex.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180faea2",
  null
  
)

export default component.exports
import {QTabs,QTab} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QTabs,QTab})
